import type { ReactNode } from 'react';

import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

import { WordBreak } from './WordBreak';

interface Props {
  readonly title: ReactNode;
  // The code of the entity, under its title.
  readonly code?: string | null;
}

export const PageTitle = ({ title, code }: Readonly<Props>) => (
  <Box sx={{ pt: 4, pb: 4 }}>
    <Typography component="h1" variant="h4">
      {title}
    </Typography>
    {!!code && (
      <Typography color="text.secondary" component="p" variant="subtitle1">
        <WordBreak>{code}</WordBreak>
      </Typography>
    )}
  </Box>
);
